const findMessageTypes = (message) => {
  let type = '';
  if (message?.message) {
    type = 'message';
  } else {
    if (message?.typeId == 2) {
      type = 'file';
    }
  }
  return type;
};
export default findMessageTypes;
